import API_URL from ".";

export const fetchEventCities = async () => {
    const response = await API_URL.eventUrl.get(
        `world-education-festival/master-event/${API_URL.id_event}`
    );

    const locations = response?.data?.data?.event_lokasi;
    return Array.isArray(locations) ? locations : [];
};

export const validateEventReferral = async (kodeReferal = "") => {
    const response = await API_URL.eventUrl.get(
        "world-education-festival/validasi-referal",
        {
            params: {
                kode_referal: kodeReferal,
                event_id: API_URL.id_event,
            },
        }
    );

    return response.data;
};

export const registerEventParticipant = async (registrationData) => {
    const response = await API_URL.eventUrl.post("register", {
        ...registrationData,
        id_konten: API_URL.id_event,
    });

    return response.data;
};
